import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { RouterLink } from "@angular/router";
import { BLOG_ARTICLES } from "../../core/constants/page-content.constants";
import { LanguageService } from "../../core/services/language.service";
import { APP_NAME, APP_CONSTANTS } from "../../core/constants/app.constants";

@Component({
  selector: "app-blog-page",
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./blog-page.component.html",
  styleUrl: "./blog-page.component.scss",
})
export class BlogPageComponent {
  readonly appName = APP_NAME;
  readonly articles = BLOG_ARTICLES;
  readonly copy = inject(LanguageService).copy;
  private readonly document = inject(DOCUMENT);
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  constructor() {
    this.title.setTitle(
      `${APP_NAME} Blog | Anonymous Chat, Privacy, and Online Safety`,
    );
    this.meta.updateTag({
      name: "description",
      content:
        "Tips, guides, and insights on anonymous chat, online privacy, safety, and connecting with people worldwide.",
    });
    this.setCanonical(`${APP_CONSTANTS.siteUrl}/blog/`);
  }

  private setCanonical(url: string) {
    let link = this.document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!link) {
      link = this.document.createElement("link");
      link.rel = "canonical";
      this.document.head.appendChild(link);
    }
    link.href = url;
  }
}
